import { handleJSON } from '@/utils/fetch-utils';
import { headers } from './index';

const { API_URL } = process.env;

export default {
  fetchScheduledActivations(limit, offset) {
    const endpoint = `${API_URL}/users/batch/schedule-activation/?limit=${limit}&offset=${offset}`;

    const options = {
      method: 'GET',
      headers: headers(),
    };
    return fetch(endpoint, options).then(handleJSON);
  },

  cancelScheduledActivations(scheduledActivationId) {
    const endpoint = `${API_URL}/users/batch/schedule-activation/${scheduledActivationId}`;

    const options = {
      method: 'DELETE',
      headers: headers(),
    };
    return fetch(endpoint, options).then(handleJSON);
  },
};
